import { Component, OnInit } from '@angular/core';
import { AbstractComponent } from '../../util/abstract.component';
import { SessaoService } from '../../services/sessao.service';

declare var $ :any;

@Component({
    selector: 'app-primeiro-acesso',
    templateUrl: './primeiro-acesso.component.html',
    styleUrls: ['./primeiro-acesso.component.css']
})
export class PrimeiroAcessoComponent extends AbstractComponent implements OnInit {

    imagem: string;
 
    constructor(private sessaoService: SessaoService) {
        super(sessaoService);
    }

    ngOnInit() {
        if((this.sessaoService.sessao.configuracaoVisual.cdIndcdPrimeiroAcesso)&&(sessionStorage.getItem("modalPrimeiroAcesso") == "true")){ 
            this.imagem = this.sessaoService.sessao.configuracaoVisual.imgPrimeiroAcesso;  
        }else if(this.sessaoService.sessao.configuracaoVisual.cdIndcdCampanha){
            this.imagem = this.sessaoService.sessao.configuracaoVisual.imgCampanha;
        }else{
            $('#m-primeiro-acesso').modal('close');
        }
        sessionStorage.setItem("modalPrimeiroAcesso", "false");
        sessionStorage.setItem("modalPrimeiroAcessoCampanha", "false");
    }

    fechar(){
        $('#m-primeiro-acesso').modal('close');
    }

}
    


// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/primeiro-acesso/primeiro-acesso.component.ts